import { NavLink } from 'react-router-dom';

// Chakra imports
import {
	Box,
	Button,
	Flex,
	HStack,
	Icon,
	Image,
	Link,
	Menu,
	MenuList,
	Stack,
	Text,
	useColorModeValue,
	useDisclosure,
	SimpleGrid
} from '@chakra-ui/react';

import { NavLink  as RouterLink } from 'react-router-dom';

// Custom components
import { TaurelLogo } from 'components/icons/Icons';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';

import routes from 'routes';

import { PATH_PUBLICO, PATH_LOGIN } from 'const/CommonConst'

export default function AuthNavbar(props: {
	logo?: JSX.Element | string;
	logoText?: string;
	secondary?: boolean;
	sidebarWidth?: any;
}) {
	const { logoText, sidebarWidth } = props;
	// Menu States
	const { isOpen: isOpenAuth, onOpen: onOpenAuth, onClose: onCloseAuth } = useDisclosure();
	const { isOpen: isOpenDashboards, onOpen: onOpenDashboards, onClose: onCloseDashboards } = useDisclosure();
	const { isOpen: isOpenMain, onOpen: onOpenMain, onClose: onCloseMain } = useDisclosure();
	const { isOpen: isOpenNft, onOpen: onOpenNft, onClose: onCloseNft } = useDisclosure();
	
	let logoColor = useColorModeValue('white', 'white');
	// Chakra color mode

	const textColor = useColorModeValue('navy.700', 'white');
	let menuBg = useColorModeValue('white', 'navy.900');
	let mainText = '#fff';
	let navbarBg = 'none';
	let navbarShadow = 'initial';
	let bgButton = 'white';
	let colorButton = 'brand.500';
	let navbarPosition = 'absolute' as 'absolute';

	let brand = (
		<Link
			as={RouterLink} 
			to={{pathname: `${PATH_PUBLICO}${PATH_LOGIN}`}}
			display='flex'
			lineHeight='100%'
			fontWeight='bold'
			justifyContent='center'
			alignItems='center'
			color={mainText}>
			<Stack direction='row' spacing='12px' alignItems='center' justify='center'>
				<TaurelLogo h='100px' w='673px' color={logoColor} />
			</Stack>
			<Text fontSize='sm' mt='3px'>
				{logoText}
			</Text>
		</Link>
	);	

	return (
		<SidebarContext.Provider value={{ sidebarWidth }}>
			<Flex
				position={navbarPosition}
				top='16px'
				left='50%'
				transform='translate(-50%, 0px)'
				background={navbarBg}
				boxShadow={navbarShadow}
				borderRadius='15px'
				px='16px'
				py='22px'
				mx='auto'
				width='1044px'
				maxW='90%'
				alignItems='center'
				zIndex='3'>
				<Flex w='100%' justifyContent={{ sm: 'start', lg: 'space-between' }}>
					{brand}
					<Box
						ms={{ base: 'auto', lg: '0px' }}
						display={{ base: 'flex', lg: 'none' }}
						justifyContent='center'
						alignItems='center'>
						<SidebarResponsive routes={routes} />
					</Box>
				</Flex>
			</Flex>
		</SidebarContext.Provider>
	);
}
